import {
  arrayOf,
  oneOfType
} from 'prop-types'
import renderable from './renderable'

export default oneOfType([renderable, arrayOf(renderable)])